import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';

import { ErrorReaderModule } from '../../seds-form-field/pipes/error-reader/error-reader.module';
import { SedsFormFieldCoreComponent } from './seds-form-field-core.component';
@NgModule({
  declarations: [SedsFormFieldCoreComponent],
  imports: [
    CommonModule,
    ErrorReaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [MatInput, SedsFormFieldCoreComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SedsFormFieldCoreModule {}
